
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flow/lp/simple-simple-registration/quiz/[id]",
      function () {
        return require("private-next-pages/flow/lp/simple-simple-registration/quiz/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flow/lp/simple-simple-registration/quiz/[id]"])
      });
    }
  